import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=49ba268e&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=49ba268e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba268e",
  null
  
)

export default component.exports